import React from 'react';
import GraphicsCarousel from '../Graphics/GraphicsCarousel';
import { PromotionalGraphicProps } from '../Graphics/PromotionalGraphic';
import { usePlatform } from '../../context/PlatformContext';
interface BookPromotionalGraphicsProps {
  bookId: string;
  bookTitle: string;
  authorId: string;
  authorName: string;
  graphics: Omit<PromotionalGraphicProps, 'bookId' | 'bookTitle' | 'authorId' | 'authorName'>[];
}
const BookPromotionalGraphics: React.FC<BookPromotionalGraphicsProps> = ({
  bookId,
  bookTitle,
  authorId,
  authorName,
  graphics
}) => {
  const {
    isAfterTide
  } = usePlatform();
  // If no graphics, don't render the section
  if (!graphics || graphics.length === 0) {
    return null;
  }
  // Add book and author info to each graphic
  const completeGraphics = graphics.map(graphic => ({
    ...graphic,
    bookId,
    bookTitle,
    authorId,
    authorName
  }));
  const viewAllLink = isAfterTide ? `/aftertide/author/${authorId}/graphics?book=${bookId}` : `/author/${authorId}/graphics?book=${bookId}`;
  return <section className="py-8 border-t border-gray-200" data-id="element-999" data-mp="9nlmfxvw271o">
      <h2 className="text-2xl font-bold mb-6" data-id="element-1000" data-mp="4ng2l3vv1ou5">Promotional Graphics</h2>
      <GraphicsCarousel graphics={completeGraphics} aspectRatio="landscape" viewAllLink={viewAllLink} viewAllText="View All Graphics" data-id="element-1001" data-mp="ilxmsrmk4j7b" />
    </section>;
};
export default BookPromotionalGraphics;